import TagContainer from './TagContainer';

export default TagContainer;
